import { Menu } from 'antd'
import { useSelector } from 'react-redux'
import { faGlobeEurope, faSchool, faUserGraduate } from '@fortawesome/pro-solid-svg-icons'

import StudentStatusSelector from '../../../Components/shared/Selectors/StudentStatusSelector'
import { isNonEmptyArray } from '../../../utils'
import FilterButton from '../../../Components/antd/Buttons/FilterButton'
import { useMemo } from 'react'
import IconLabel, { FontSizes } from '../../../Components/icons/IconLabel'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { StudentStatusTypes } from '../../../utils/entities/student'
import SchoolsSelector from '../../../Components/shared/Selectors/School/SchoolsSelector'
import NationalitiesSelector from '../../../Components/shared/Selectors/NationalitiesSelector'

const DEFAULT_FILTERS = {
  status: [StudentStatusTypes.CURRENTLY_STUDYING],
  schools: [],
  nationalities: []
}

const StudentFilters = ({ filters, onFiltersChange }) => {
  const t = useSelector(selectTranslate)

  const activeFilters = useMemo(() => {
    let count = 0

    if (isNonEmptyArray(filters?.status)) {
      count += 1
    }

    if (isNonEmptyArray(filters?.schools)) {
      count += 1
    }

    if (isNonEmptyArray(filters?.nationalities)) {
      count += 1
    }

    return count
  }, [filters])

  const handleFiltersChange = (key, value) => {
    const newFilters = { ...filters, [key]: value }

    onFiltersChange(newFilters)
  }

  return (
    <FilterButton filterCount={activeFilters} onReset={() => onFiltersChange(DEFAULT_FILTERS)}>
      <Menu inlineIndent={10} style={{ width: '200px' }}>
        <Menu.ItemGroup title={<IconLabel fontSize={FontSizes.SMALL} padding={0} icon={faUserGraduate} text={t('common.status')} />}>
          <Menu.Item key='state' disabled style={{ cursor: 'default' }}>
            <StudentStatusSelector style={{ width: '100%' }} multiple='multiple' values={filters?.status} onChange={value => handleFiltersChange('status', value)} />
          </Menu.Item>
        </Menu.ItemGroup>
        <Menu.ItemGroup title={<IconLabel fontSize={FontSizes.SMALL} padding={0} icon={faSchool} text={t('common.school')} />}>
          <Menu.Item key='state' disabled style={{ cursor: 'default' }}>
            <SchoolsSelector style={{ width: '100%' }} multiple='multiple' values={filters?.schools} onChange={value => handleFiltersChange('schools', value)} />
          </Menu.Item>
        </Menu.ItemGroup>
        <Menu.ItemGroup title={<IconLabel fontSize={FontSizes.SMALL} padding={0} icon={faGlobeEurope} text={t('common.nationality')} />}>
          <Menu.Item key='state' disabled style={{ cursor: 'default' }}>
            <NationalitiesSelector style={{ width: '100%' }} multiple='multiple' values={filters?.nationalities} onChange={value => handleFiltersChange('nationalities', value)} />
          </Menu.Item>
        </Menu.ItemGroup>
      </Menu>
    </FilterButton>
  )
}

export default StudentFilters
